import axios from './utils/axios';
import generateCRUDOps from './utils/generateCrud';

const pathPrefix = `/documents/`;

const DocumentService = {
  ...generateCRUDOps(pathPrefix, 'documents'),
  bulkUploadFinish: async (snapshotids: number[]) => {
    return axios.post(`${pathPrefix}documents/bulk-finish-upload/`, {
      snapshot_ids: snapshotids,
    });
  },
};

export default DocumentService;
